import React, { useState, useEffect, useMemo } from "react";
import "./How.css";
import { Container, Image } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import first from "../../../../Asset/wo-analysis.png";
import second from "../../../../Asset/wo-design.png";
import third from "../../../../Asset/wo-development.png";
import fourth from "../../../../Asset/wo-testing.png";
import fifth from "../../../../Asset/wo-golive.png";

const How = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [hoverIndex, setHoverIndex] = useState(null);
  const placements = [
    "Analysis",
    "Design",
    "Development",
    "Testing",
    "Go Live",
  ];

  const isActiveImage = (index) => {
    return index === activeIndex ? "is-active" : "";
  };
  const stepsCount = 5;

  const stepsRefs = useMemo(
    () => Array.from({ length: stepsCount }, () => React.createRef()),
    [stepsCount]
  );
  const handleClick = (index) => {
    setActiveIndex(index);
    window.scrollTo({
      behavior: "smooth",
      left: 0,
      top: stepsRefs[index].current.offsetTop + 80,
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      stepsRefs.forEach((elementRef, index) => {
        if (elementRef.current) {
          const rect = elementRef.current.getBoundingClientRect();
          const isVisible =
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
              (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <=
              (window.innerWidth || document.documentElement.clientWidth);
          if (isVisible) {
            setActiveIndex(index);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [stepsRefs]);

  return (
    <>
      <section className="HowWeWork-section">
        <div className="page-header">
          <Container>
            <div className="page-title text-center">
              <h1>How we work</h1>
            </div>
          </Container>
        </div>
        <ul className="project-nav">
          {placements.map((placement, index) => (
            <OverlayTrigger
              key={placement}
              placement="left"
              overlay={
                <Tooltip id={`tooltip-${placement}`} className="custom-tooltip">
                  <strong>{placement}</strong>.
                </Tooltip>
              }
              show={hoverIndex === index || activeIndex === index}
            >
              <li
                className={activeIndex === index ? "is-active" : ""}
                onClick={(e) => {
                  e.stopPropagation();
                  handleClick(index);
                }}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(null)}
              >
                <span className="dot"></span>
              </li>
            </OverlayTrigger>
          ))}
        </ul>
        <section className="main-section-howWeWork">
          <Container>
            <div className="row align-items-start">
              <div className="col-md-6 position-sticky-bar">
                <div className="left-image-block">
                  <span className={`work-analysis-img ${isActiveImage(0)}`}>
                    <Image src={first} className="w-100" />
                  </span>
                  <span className={`work-analysis-img ${isActiveImage(1)}`}>
                    <Image src={second} className="w-100" />
                  </span>
                  <span className={`work-analysis-img ${isActiveImage(2)}`}>
                    <Image src={third} className="w-100" />
                  </span>
                  <span className={`work-analysis-img ${isActiveImage(3)}`}>
                    <Image src={fourth} className="w-100" />
                  </span>
                  <span className={`work-analysis-img ${isActiveImage(4)}`}>
                    <Image src={fifth} className="w-100" />
                  </span>
                </div>
              </div>
              <div className="col-xl-6 col-lg-12">
                <div ref={stepsRefs[0]} className="work-analysis-step">
                  <h1 className="step-title" data-count="01">
                    Analysis
                  </h1>
                  <div className="work-analysis-step-info">
                    <div className="step-image-block">
                      <Image src={first} />
                    </div>
                    <div className="step-info-content">
                      <p>
                        A results-driven prototype is developed based on
                        diversified experiments to ensure a high degree of
                        quality and detail in creating an authentic digital
                        connection.
                      </p>
                    </div>
                  </div>
                </div>
                <div ref={stepsRefs[1]} className="work-analysis-step">
                  <h1 className="step-title" data-count="02">
                    Design
                  </h1>
                  <div className="work-analysis-step-info">
                    <div className="step-image-block">
                      <Image src={second} />
                    </div>
                    <div className="step-info-content">
                      <p>
                        The various stages are Research, Wireframes, User
                        Testing, Look and Feel Design, Front-End Code
                        Development, and Integration Support.
                      </p>
                      <p>
                        This guarantees that our esteemed clients get
                        arrangements that are both valuable to their particular
                        necessities and are reasonable, as well.
                      </p>
                    </div>
                  </div>
                </div>
                <div ref={stepsRefs[2]} className="work-analysis-step">
                  <h1 className="step-title" data-count="03">
                    Development
                  </h1>
                  <div className="work-analysis-step-info">
                    <div className="step-image-block">
                      <Image src={third} />
                    </div>
                    <div className="step-info-content">
                      <p>
                        As a leading web and mobile app development company, we
                        offer cutting-edge solutions that stand the test of time
                        across multiple environments, including production and
                        staging.
                      </p>
                    </div>
                  </div>
                </div>
                <div ref={stepsRefs[3]} className="work-analysis-step">
                  <h1 className="step-title" data-count="04">
                    Testing
                  </h1>
                  <div className="work-analysis-step-info">
                    <div className="step-image-block">
                      <Image src={fourth} />
                    </div>
                    <div className="step-info-content">
                      <p>
                        To impart a clear big picture of design experience
                        benchmarking, blueprints, personas, and journey maps of
                        ideal consumers, we use state-of-the-art testing
                        techniques to refine our designs on Omni-channel
                        platforms.
                      </p>
                    </div>
                  </div>
                </div>
                <div ref={stepsRefs[4]} className="work-analysis-step">
                  <h1 className="step-title" data-count="05">
                    Go live
                  </h1>
                  <div className="work-analysis-step-info">
                    <div className="step-image-block">
                      <Image src={fifth} />
                    </div>
                    <div className="step-info-content">
                      <p>
                        The combination of proven ideation techniques and a
                        client-centric approach enables us to develop roadmaps
                        while mapping your business journey to define problems
                        related to people.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </section>
    </>
  );
};

export default How;
